import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import type { SessionUser } from './session-types'

type SessionState = {
  token: string | null
  user: SessionUser | null
  setSession: (token: string, user: SessionUser) => void
  setUser: (user: SessionUser) => void
  clear: () => void
}

export const useSession = create<SessionState>()(
  persist(
    (set) => ({
      token: null,
      user: null,
      setSession: (token, user) => {
        set({ token, user })
      },
      setUser: (user) => {
        set({ user })
      },
      clear: () => {
        set({ token: null, user: null })
      },
    }),
    { name: 'vp-session' },
  ),
)

export function getAuthToken(): string | null {
  return useSession.getState().token
}
